import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialGroupLaboratoryPersonnelsApi = {
    getTrialGroupLaboratoryPersonnels: (): Observable<Dtos.GetTrialGroupLaboratoryPersonnelsResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupLaboratoryPersonnels = new Dtos.GetTrialGroupLaboratoryPersonnels();

        //Send request.
        const response: Promise<Dtos.GetTrialGroupLaboratoryPersonnelsResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialGroupLaboratoryPersonnelById: (id: number): Observable<Dtos.GetTrialGroupLaboratoryPersonnelByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupLaboratoryPersonnelById = new Dtos.GetTrialGroupLaboratoryPersonnelById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupLaboratoryPersonnelByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialGroupLaboratoryPersonnelByLaboratoryId: (trialGroupLaboratoryId: number): Observable<Dtos.GetTrialGroupLaboratoryPersonnelByLaboratoryIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupLaboratoryPersonnelByLaboratoryId = new Dtos.GetTrialGroupLaboratoryPersonnelByLaboratoryId();

        request.trialGroupLaboratoryId = trialGroupLaboratoryId;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupLaboratoryPersonnelByLaboratoryIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialGroupLaboratoryPersonnel: (trialGroupLaboratoryPersonnel: Dtos.TrialGroupLaboratoryPersonnel): Observable<Dtos.SetTrialGroupLaboratoryPersonnelResponse> => {

        let request: Dtos.SetTrialGroupLaboratoryPersonnel = new Dtos.SetTrialGroupLaboratoryPersonnel();

        request.trialGroupLaboratoryPersonnel = trialGroupLaboratoryPersonnel;

        // send request
        const response: Promise<Dtos.SetTrialGroupLaboratoryPersonnelResponse> = client.post(request);

        return Observable.from(response);

    },
    createTrialGroupLaboratoryPersonnel: (trialGroupLaboratoryId: number): Observable<Dtos.CreateTrialGroupLaboratoryPersonnelResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialGroupLaboratoryPersonnel = new Dtos.CreateTrialGroupLaboratoryPersonnel();

        request.trialGroupLaboratoryId = trialGroupLaboratoryId;

        //Send request.
        const response: Promise<Dtos.CreateTrialGroupLaboratoryPersonnelResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialGroupLaboratoryPersonnel: (trialGroupLaboratoryPersonnel: Dtos.TrialGroupLaboratoryPersonnel): Observable<Dtos.ValidateTrialGroupLaboratoryPersonnelResponse> => {

        let request: Dtos.ValidateTrialGroupLaboratoryPersonnel = new Dtos.ValidateTrialGroupLaboratoryPersonnel();

        request.trialGroupLaboratoryPersonnel = trialGroupLaboratoryPersonnel;

        // send request
        const response: Promise<Dtos.ValidateTrialGroupLaboratoryPersonnelResponse> = client.post(request);

        return Observable.from(response);

    }
}